"use strict";

var React = require("react/addons");

var Footer = React.createClass({
  displayName: "Footer",

  render: function render() {
    return React.createElement(
      "footer",
      { className: "footer" },
      React.createElement(OFSCredit, null),
      React.createElement(
        "div",
        { className: "footer__links" },
        React.createElement(
          "a",
          { href: "http://tech.onefinestay.com/", className: "footer__link" },
          "Blog"
        ),
        React.createElement(
          "a",
          { href: "https://github.com/onefinestay", className: "footer__link" },
          "Github"
        ),
        React.createElement(
          "a",
          { href: "https://twitter.com/buildingOFS", className: "footer__link" },
          "Twitter"
        )
      )
    );
  }
});

var OFSCredit = React.createClass({
  displayName: "OFSCredit",

  render: function render() {
    return React.createElement(
      "div",
      { className: "ofs-credit" },
      React.createElement(
        "p",
        { className: "ofs-credit__text" },
        "Built by"
      ),
      React.createElement(
        "a",
        { href: "http://www.onefinestay.com/", className: "ofs-credit__logo" },
        React.createElement("img", { src: "img/logo.png" })
      )
    );
  }
});

module.exports = Footer;


/*****************
 ** WEBPACK FOOTER
 ** ./example/components/footer.jsx
 ** module id = 4
 ** module chunks = 0
 **/